
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'
import { getLiveClickIds } from '@/utils/clickIds';


const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

export default {
  name: 'TeflBrochure',
  components: {
    ValidationProvider,
    ValidationObserver,
    // VueTelInput:  () => import('vue-tel-input').then(m => m.VueTelInput),
  },
  props: {
    images:{
      type: Boolean,
      default: false
    },
    redirect: {
      type: Boolean,
      default: true
    },
    squeeze:{
      default: 'false',
      type:String
    },
    phone:{
      default: 'false',
      type:String
    }
  },
  data() {
    return {
      loading: false,
      a: Math.ceil(Math.random() * 10),
      b: Math.ceil(Math.random() * 10),
      showError: false,
      answer: null,
      form: { download: true },
      messageSent: false,
      merge_vars: { STUDY_LOC: 'select'},
      vueTelInputOptions :{
        dropdownOptions:{
          showSearchBox:true,
          showFlags:true,
          showDialCodeInList:true,
          width:'250px'
        },
        inputOptions:{
          placeholder:'',
        },
        mode:'international',
        validCharactersOnly:true,
        preferredCountries:['GB', 'US'],
      }
    }
  },
  computed: {
    ...mapGetters({
      userId: 'user/id',
      detectedTimezone: 'geolocation/detectedTimezone',
    }),
    bottest() {
      return `What is ${this.a} + ${this.b} ?`
    },
    c() {
      return parseInt(this.a + this.b)
    },
    countries(){
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    },
  },
  methods: {
    changePhoneCountry(country) {
      this.countryCode = country.iso2
    },
    setCountry(code) {
      this.form.country = this.countries.find(country => country.value === code).label
    },
    async Submit() {
      console.log('Submit the form')
      this.loading = true
      console.log(this.form)
      // const userId = this.userId
      const teflID = new URLSearchParams(window.location.search).get(
        "teflid"
      );
      const dataToSend = { 
        // mc_request:'brochure_request',
        email: this.form.email, 
        merge_vars: this.merge_vars, 
        // ...(this.userId !== "" ? {id:userId}: {}),
      }

      if(teflID) { // check if teflid parameter is set to anything
        dataToSend.referrer = teflID
      } else {
          const teflID2 = localStorage.getItem('tefl_teflid');
          if(teflID2) { // check if teflid parameter is set to anything
            dataToSend.referrer = teflID2
          }
      }

      // CLICK IDS — every live one, from the shared util. Listing them here
      // individually is how msclkid came to be captured, stored and never sent.
      const ids = getLiveClickIds();
      Object.assign(dataToSend, ids);
      dataToSend.click_ids = ids;

      // TOUCHPOINTS — capture the journey at lead creation time
      try {
        const touchpoints = JSON.parse(localStorage.getItem('tefl_touchpoints'));
        if (touchpoints && touchpoints.length) dataToSend.touchpoints = touchpoints;
      } catch (e) {
        console.warn('Could not parse touchpoints from localStorage');
      }
      
      const result = await this.$axios
        .$post(
        `${process.env.DATA_URL}/klaviyo/automations/brochure_request/send`,
            dataToSend
        )
        /*
        .$post(
          `${process.env.DATA_URL}/mailchimp/automations/brochure_request/send`,
            dataToSend
        )
        */
        .catch((error) => {
          console.log('Error', error)
        })
      
      console.log('got', result)
    

      if (result.statusCode === 204) {
        if ( window ) {

          // Identify via plugin
          this.$rs.identify(this.form.email, {
            userId: this.userId,
            name: this.merge_vars.FNAME + ' ' + this.merge_vars.LNAME,
            email: this.form.email,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via rudderstack
          this.$rs.track("Generate Lead", {
            form_name: 'brochure form',
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })

          // Track via GTM
          this.$gtm.push({
            event: 'generate_lead',
            form_name: 'brochure form',
            enhanced_conversion_data: {
                "email": this.form.email
            },
            user_data: {
              "email": this.form.email
            }
          });
          
        }
        if(this.$props.redirect){
          // this.loading = false
          this.messageSent = true
          // window.location.replace(location.protocol + '//' + location.host +"/about-us/brochure-request-confirmation/")
          // window.location.pathname = '/about-us/brochure-request-confirmation/';
        }else{
          this.loading = false
          this.$emit("success")
        }
      }
    },
  },
}
